var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.984375 10C0.984375 10.3818 1.13026 10.7075 1.43324 10.9995L10.1862 19.5684C10.4218 19.8154 10.736 19.939 11.0951 19.939C11.8245 19.939 12.3968 19.3774 12.3968 18.6362C12.3968 18.2769 12.251 17.9512 12.0041 17.7041L4.11523 10L12.0041 2.2959C12.251 2.0376 12.3968 1.71191 12.3968 1.35254C12.3968 0.622559 11.8245 0.0610352 11.0951 0.0610352C10.736 0.0610352 10.4218 0.18457 10.1862 0.431641L1.43324 9.00049C1.13026 9.29248 0.995597 9.61816 0.984375 10Z",
    fill: "#E81111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronleft);
export default __webpack_public_path__ + "static/media/chevron.left.c72607f5a9c097259377260b1d268016.svg";
export { ForwardRef as ReactComponent };